import React from 'react';
import { T } from 'shared/helper/translate';
import RubriqAbstractStatus from './RubriqAbstractStatus';
var RubriqAbstractHeader = function RubriqAbstractHeader(_ref) {
  var onSubmitAbstract = _ref.onSubmitAbstract;
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom d-flex justify-content-between align-items-center justify-content-md-end gap-md-4 py-2"
  }, /*#__PURE__*/React.createElement(RubriqAbstractStatus, null), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "not-global btn btn-primary rounded-3",
    onClick: function onClick() {
      return onSubmitAbstract();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "submit abstract"
  })));
};
export default RubriqAbstractHeader;